// extracted by mini-css-extract-plugin
module.exports = {"fullPageContainer":"fullPageContainer__-HsmD","form":"form__36D9E","input":"input__11jMl","submitButton":"submitButton__1AjfF","error":"error__AKzyD"};